export default __webpack_public_path__ + "static/media/svg-5.99f0b4fb.svg";